/**
 * Info Tooltip Module
 * Handles click events to show/hide tooltip content
 */
document.addEventListener("DOMContentLoaded", () => {
	initInfoTooltips();
});

// Global handlers for outside click and escape key (only added once)
let outsideClickHandler = null;
let escapeKeyHandler = null;

function initInfoTooltips() {
	const tooltipWrappers = document.querySelectorAll('.pds-info-tooltip-wrapper');
	
	if (!tooltipWrappers.length) {
		return;
	}
	
	// Add global handlers only once
	if (!outsideClickHandler) {
		outsideClickHandler = (e) => {
			tooltipWrappers.forEach((wrapper) => {
				if (!wrapper.contains(e.target)) {
					const trigger = wrapper.querySelector('.pds-info-tooltip-trigger');
					const content = wrapper.querySelector('.pds-info-tooltip-content');
					if (trigger && content) {
						closeTooltip(trigger, content);
					}
				}
			});
		};
		document.addEventListener('click', outsideClickHandler);
	}
	
	if (!escapeKeyHandler) {
		escapeKeyHandler = (e) => {
			if (e.key === 'Escape') {
				tooltipWrappers.forEach((wrapper) => {
					const trigger = wrapper.querySelector('.pds-info-tooltip-trigger');
					const content = wrapper.querySelector('.pds-info-tooltip-content');
					if (trigger && content && trigger.getAttribute('aria-expanded') === 'true') {
						closeTooltip(trigger, content);
					}
				});
			}
		};
		document.addEventListener('keydown', escapeKeyHandler);
	}
	
	// Add click handler to each tooltip
	tooltipWrappers.forEach((wrapper) => {
		const trigger = wrapper.querySelector('.pds-info-tooltip-trigger');
		const content = wrapper.querySelector('.pds-info-tooltip-content');
		
		if (!trigger || !content) {
			return;
		}
		
		// Check if already initialized
		if (trigger.dataset.initialized === 'true') {
			return;
		}
		
		trigger.dataset.initialized = 'true';
		
		const tooltipTitleElement = wrapper.querySelector('.pds-info-tooltip-title');
		const tooltipTitle = (tooltipTitleElement ? tooltipTitleElement.textContent : '').trim() || 'tooltip';
		// Toggle tooltip on button click
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			
			const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
			
			console.log('[Tooltip]', tooltipTitle, 'click, expanded:', isExpanded);
			// Close all other tooltips first
			closeAllTooltips();
			
			if (!isExpanded) {
				openTooltip(trigger, content);
			} else {
				closeTooltip(trigger, content);
			}
		});
	});
}

/**
 * Open tooltip
 */
function openTooltip(trigger, content) {
	trigger.setAttribute('aria-expanded', 'true');
	content.classList.add('is-active');
	
	// Add animation delay for smooth transition
	setTimeout(() => {
		content.style.opacity = '1';
		content.style.visibility = 'visible';
		content.style.transform = 'scale(1)';
	}, 10);
}

/**
 * Close tooltip
 */
function closeTooltip(trigger, content) {
	trigger.setAttribute('aria-expanded', 'false');
	content.style.opacity = '0';
	content.style.visibility = 'hidden';
	content.style.transform = 'scale(0.1)';
	
	setTimeout(() => {
		content.classList.remove('is-active');
	}, 300);
}

/**
 * Close all tooltips
 */
function closeAllTooltips() {
	const allTriggers = document.querySelectorAll('.pds-info-tooltip-trigger[aria-expanded="true"]');
	const allContents = document.querySelectorAll('.pds-info-tooltip-content.is-active');
	
	allTriggers.forEach((trigger) => {
		trigger.setAttribute('aria-expanded', 'false');
	});
	
	allContents.forEach((content) => {
		content.style.opacity = '0';
		content.style.visibility = 'hidden';
		content.style.transform = 'scale(0.1)';
		
		setTimeout(() => {
			content.classList.remove('is-active');
		}, 300);
	});
}

